function initialPackagePrice() {
  return {
    fullPriceAmount: 0,
    discountedPriceAmount: 0,
  };
}

function initialUiState() {
  return {
    showBackBtn: true,
    isLoading: false,
    isManualAddress: false,
    isViaShareLink: false,
    minTenancyLengthMonths: 9,
    carouselTexts: [],
  };
}

function initialReferralState() {
  return {
    isValid: false,
    code: "",
    message: "",
    showMessage: false,
  };
}

function initialAffiliateState() {
  return {
    isValid: false,
    code: "",
    message: "",
    showMessage: false,
  };
}

function initialHouseInformationState() {
  return {
    postcode: "",
    address: {},
    startDate: "",
    endDate: "",
    broadbandUrgent: true,
    broadbandDate: "",
    lettingAgentName: "",
  };
}

function initialPersonalDetailsState() {
  return {
    leadType: null,
    firstname: "",
    lastname: "",
    email: "",
    tel: "",
    termsAgreed: false,
    allowPromotions: true,
    whatsappConsent: false,
  };
}

function initialBankDetailsState() {
  return {
    firstname: "",
    lastname: "",
    sortCode: "",
    accountNumber: "",
    accountHolder: false,
  };
}

function initialAccountState() {
  return {
    guid: "",
    accountCreator: "",
    address: "",
    postcode: "",
    tenancyStartDate: "",
    tenancyEndDate: "",
    broadbandDate: "",
    products: [],
    joinLink: "",
    remainingHousemates: 0,
    pppwPence: 0,
    nonDiscountedPppwPence: 0,
    usedDiscount: false,
    discountDescription: "",
  };
}

function initialDiscountState() {
  return {
    isValid: false,
    isValidating: false,
    inputRevealed: false,
    offer: null,
    aff: null,
    code: "",
    name: "",
    description: "",
    errorMsg: "",
    productCode: "",
    productType: "",
  };
}

function initialCookieState() {
  return {
    basic: true,
    personal: false,
  };
}

export {
  initialUiState,
  initialReferralState,
  initialAffiliateState,
  initialDiscountState,
  initialHouseInformationState,
  initialPackagePrice,
  initialPersonalDetailsState,
  initialBankDetailsState,
  initialAccountState,
  initialCookieState,
};
